export default "__VITE_ASSET__DpEuD42L__"